import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageSelectorComponent } from './components/language-selector-no-flag/language-selector.component';
import { FormsModule } from '@angular/forms';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { LanguageButtonSelectComponent } from './language-button-select/language-button-select.component';
import { NgbDropdownModule, NgbOffcanvasModule } from '@ng-bootstrap/ng-bootstrap';
import { LanguageSelectorWithFlagComponent } from './components/language-selector-with-flag/language-selector-with-flag.component';
import { CountryFlagPipe } from './components/country-flag.pipe';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
@NgModule({
  declarations: [
    LanguageSelectorComponent, 
    LanguageButtonSelectComponent, 
    LanguageSelectorWithFlagComponent,
    ],
  imports: [
    CommonModule,
    FormsModule,
    FGBSharedModule,
    NgbDropdownModule,
    CountryFlagPipe,
    NgbOffcanvasModule,
    DirectivesModule
  ],
  exports: [
    LanguageSelectorComponent, 
    LanguageButtonSelectComponent, 
    LanguageSelectorWithFlagComponent ],
})
export class LanguageSelectorModule {}
